// firebase
import * as firebase from "firebase/app";
// import * as firebase from "firebase-admin";
import "firebase/auth";
import 'firebase/analytics';
import "firebase/firestore";

var firebaseConfig = {
  apiKey: "AIzaSyDn2xRxZrlg_-NzaSa24NJl6q_fAYrVA5k",
  authDomain: "atsumaritai.firebaseapp.com",
  databaseURL: "https://atsumaritai.firebaseio.com",
  projectId: "atsumaritai",
  storageBucket: "atsumaritai.appspot.com",
  messagingSenderId: "122495633352",
  appId: "1:122495633352:web:49414df86475dc49eca2fd",
  measurementId: "G-YQGQ0JWHGB"
};

// Initialize Firebase
firebase.initializeApp(firebaseConfig);
firebase.analytics().logEvent('notification_received');
export const db = firebase.firestore();
export const auth = firebase.auth();
// firebase.analytics();
// Initialize Firebase
